const STORAGE_KEY = "strm_auth_token";

type Listener = (token: string | null) => void;
const listeners = new Set<Listener>();

const readStorage = (): string | null => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

let currentToken: string | null =
  typeof window === "undefined" ? null : readStorage();

export const getAuthToken = () => currentToken;

export const setAuthToken = (token: string | null) => {
  currentToken = token;
  try {
    if (token) {
      window.localStorage.setItem(STORAGE_KEY, token);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Storage can be unavailable (private mode); the in-memory token still works.
  }
  listeners.forEach((listener) => listener(token));
};

export const subscribeAuthToken = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
